import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { SessionStorage } from '@df/browser/storage/decorator/session-storage';
import { UiComponent } from '@df/ui/ui.component';
import { NPageHeader } from '../page-header.component';
import { App } from '@df/core/app';

@Component({
    selector: 'page-header-promobar',
    templateUrl: 'page-header-promobar.html',
    styleUrls: ['page-header-promobar.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderPromobarComponent extends UiComponent implements OnInit, OnDestroy, OnChanges {
    @Input()
    content?: NPageHeader.IBlockDataContent;

    private app = inject(App);

    @SessionStorage('promobarHiden')
    private hidden?: boolean;
    protected isManuallyHidden = false;

    override ngOnInit(): void {
        if (this.hidden) {
            this.isManuallyHidden = true;
        }
        super.ngOnInit();
    }

    override ngOnChanges(changes): void {
        super.ngOnChanges(changes);
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    protected close() {
        this.hidden = true;
        this.isManuallyHidden = true;
    }

    get pcSlidesGap() {
        return 0;
    }

    get pcSlides() {
        return 1;
    }

    get pcSlidesCeil() {
        return Math.ceil(this.pcSlides);
    }

    get isPlatformBrowser() {
        return this.app.isPlatformBrowser;
    }
}
